import { CircularProgress, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomChart from "../../../components/Common/CustomChart";
import { useDispatch, useSelector } from "react-redux";
import LinkBox from "../../../components/Content/LinkBox";
import DroppableArea from "../../../components/StartPage/DroppableArea";
import SendInviteModal from "../../../components/Modals/SendInviteModal";
import { ConfirmationSnackbar } from "../../../components/Common/CustomSnackbar";
import { sendInvite } from "../../../redux/actions/user.dispatcher";
import { getWheelOfLife } from "../../../redux/actions/user.dispatcher";
import dayjs from "dayjs";
import axiosInstance from "../../../utils/config/config";
import { useQuickLinksItems } from "../../../context/QuickLinksContext";
import TutorialVideoModal from "../../../components/Modals/TutorialVideoModal";
import logoRarge from "../../../assets/images/logo_lg.png";

import {
  RootWrapper,
  LogoWrapper,
  StyledLogo,
  ContentRow,
  ContentWrapper,
  ContentColumn,
  VideoSection,
  VideoIframe,
  VideoLinkText,
  VideoLinkSpan,
  LessonBox,
  LessonTitle,
  LessonItemTitle,
  IncomeBox,
  IncomeText,
  IncomeBoldSpan,
  StyledBackdrop,
} from "./StartPage.styles";
import {
  TUTORIAL_VIDEO_URL,
  SNACKBAR_SUCCESS_TEXT,
} from "./StartPage.constants";
import { Gapper } from "../../../components/ui/Gapper";

const StartPage = ({ droppedItems, setDroppedItems }) => {
  const { userData } = useSelector((state) => state.user);
  const { setacimTab, setSelectedTab, setLessonContent } = useQuickLinksItems();
  const smScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const [sendInviteModalState, setSendInviteModalState] = useState(false);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [todaysLesson, setTodaysLesson] = useState(null);
  const [videoModal, setVideoModal] = useState(false);

  const dispatch = useDispatch();

  const handleInvite = async () => {
    try {
      setLoading(true);
      const sendInv = await sendInvite();

      if (sendInv) {
        setSuccess(true);
        setSendInviteModalState(false);
      }
    } catch (error) {
      console.log(error, "error sending invites");
    } finally {
      setLoading(false);
    }
  };

  const handleLessonClick = () => {
    setSelectedTab("miracles");
    setacimTab("lessons");
    setLessonContent(todaysLesson?.content);
  };

  const getTodaysLesson = async () => {
    try {
      const response = await axiosInstance.get("/courselessons/todays-lesson");

      if (response.status === 200) {
        setTodaysLesson(response.data?.lesson);
      }
    } catch (error) {
      console.log("Error getting today's lesson", error);
    }
  };

  useEffect(() => {
    getTodaysLesson();
    dispatch(getWheelOfLife());
  }, [dispatch]);

  const annualRate = (
    userData?.ratePerClient *
    userData?.clients *
    userData?.sessionLength *
    52
  ).toLocaleString();

  const weeklyRate = (
    userData?.ratePerClient *
    userData?.clients *
    userData?.sessionLength
  ).toLocaleString();

  return (
    <RootWrapper>
      <StyledBackdrop open={loading}>
        <CircularProgress color="inherit" />
      </StyledBackdrop>
      <ContentRow>
        <LogoWrapper>
          <StyledLogo src={logoRarge} alt="IIH Logo" />
        </LogoWrapper>
        <ContentWrapper>
          <ConfirmationSnackbar
            snackbarState={success}
            handleSnackbarClose={() => setSuccess(false)}
            text={SNACKBAR_SUCCESS_TEXT}
          />

          <SendInviteModal
            open={sendInviteModalState}
            handleClose={() => setSendInviteModalState(false)}
            handleInvite={handleInvite}
          />

          <TutorialVideoModal
            open={videoModal}
            handleClose={() => setVideoModal(false)}
            videoUrl={TUTORIAL_VIDEO_URL}
          />

          <ContentColumn>
            {!smScreen && (
              <DroppableArea
                droppedItems={droppedItems || []}
                setDroppedItems={setDroppedItems}
              />
            )}

            {userData?.role === "admin" && (
              <LinkBox
                invite
                mb={0}
                onClick={() => setSendInviteModalState(true)}
              />
            )}

            <VideoSection onClick={() => setVideoModal(true)}>
              <VideoIframe
                src={TUTORIAL_VIDEO_URL}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
              <VideoLinkText>
                Click here{" "}
                <VideoLinkSpan component="span">
                  to get more details.
                </VideoLinkSpan>
              </VideoLinkText>
            </VideoSection>
            <Gapper gap={20}>
              {todaysLesson && userData?.showAcimLesson && (
                <LessonBox onClick={handleLessonClick}>
                  <LessonTitle>ACIM Today's Lesson:</LessonTitle>
                  {todaysLesson?.title?.map((title, index) => (
                    <LessonItemTitle key={index}>"{title}"</LessonItemTitle>
                  ))}
                </LessonBox>
              )}

              {userData?.showTotalIncome &&
                userData?.clients &&
                userData?.ratePerClient && (
                  <IncomeBox>
                    <IncomeText>
                      On or before
                      <IncomeBoldSpan component="span">
                        {" "}
                        {dayjs(userData?.startDate).format("MM/DD/YYYY")}
                      </IncomeBoldSpan>
                      , I see
                      <IncomeBoldSpan component="span">
                        {" "}
                        {userData?.clients}
                      </IncomeBoldSpan>{" "}
                      full-paying clients per week to earn
                      <IncomeBoldSpan component="span">
                        {" "}
                        ${weeklyRate}
                      </IncomeBoldSpan>{" "}
                      per week and
                      <IncomeBoldSpan component="span">
                        {" "}
                        ${annualRate}
                      </IncomeBoldSpan>{" "}
                      per year.
                    </IncomeText>
                  </IncomeBox>
                )}
              {userData?.showWheelOfLife && userData?.wheelOfLife?.length > 0 && (
                <CustomChart />
            )}
            </Gapper>
          </ContentColumn>
        </ContentWrapper>
      </ContentRow>
    </RootWrapper>
  );
};

export default StartPage;
